import { FC } from 'react';
import { Box, Table, Text, Badge, Button, HStack, Spinner } from '@chakra-ui/react';
import { LuEye } from 'react-icons/lu';
import { AIAnalysisHistory } from '@/types/aiManagement';
import { format } from 'date-fns';
import { ja } from 'date-fns/locale';

interface HistoryTableProps {
  histories: AIAnalysisHistory[];
  loading: boolean;
  onViewDetail: (history: AIAnalysisHistory) => void;
  hasMore: boolean;
  onLoadMore: () => void;
  loadingMore: boolean;
}

/**
 * 分析履歴テーブルコンポーネント
 */
export const HistoryTable: FC<HistoryTableProps> = ({
  histories,
  loading,
  onViewDetail,
  hasMore,
  onLoadMore,
  loadingMore,
}) => {
  if (loading) {
    return (
      <Box p={8} textAlign="center">
        <Spinner size="lg" />
        <Text mt={4} color="gray.500">
          読み込み中...
        </Text>
      </Box>
    );
  }

  if (histories.length === 0) {
    return (
      <Box p={8} textAlign="center" bg="gray.50" borderRadius="lg">
        <Text color="gray.500">分析履歴がありません</Text>
      </Box>
    );
  }

  return (
    <Box>
      <Table.Root size="sm">
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader>日時</Table.ColumnHeader>
            <Table.ColumnHeader>メス犬</Table.ColumnHeader>
            <Table.ColumnHeader>候補数</Table.ColumnHeader>
            <Table.ColumnHeader>ステータス</Table.ColumnHeader>
            <Table.ColumnHeader>実行時間</Table.ColumnHeader>
            <Table.ColumnHeader>操作</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {histories.map((history) => (
            <Table.Row key={history.id}>
              <Table.Cell>
                <Text fontSize="sm">
                  {format(history.createdAt.toDate(), 'MM/dd HH:mm', { locale: ja })}
                </Text>
              </Table.Cell>
              <Table.Cell>
                <Text fontWeight="medium">{history.input.femaleName}</Text>
              </Table.Cell>
              <Table.Cell>
                <Text>{history.input.candidateIds.length}頭</Text>
              </Table.Cell>
              <Table.Cell>
                {history.status === 'success' ? (
                  <Badge colorPalette="green" fontSize="xs">
                    成功
                  </Badge>
                ) : (
                  <Badge colorPalette="red" fontSize="xs">
                    エラー
                  </Badge>
                )}
              </Table.Cell>
              <Table.Cell>
                {history.status === 'success' ? (
                  <Text fontSize="sm">{(history.executionTime / 1000).toFixed(1)}秒</Text>
                ) : (
                  <Text fontSize="sm" color="gray.400">
                    -
                  </Text>
                )}
              </Table.Cell>
              <Table.Cell>
                <Button size="xs" variant="outline" onClick={() => onViewDetail(history)}>
                  <LuEye />
                  詳細
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>

      {/* もっと読み込むボタン */}
      {hasMore && (
        <HStack justify="center" mt={4}>
          <Button
            size="sm"
            variant="outline"
            onClick={onLoadMore}
            loading={loadingMore}
            disabled={loadingMore}
          >
            もっと読み込む
          </Button>
        </HStack>
      )}
    </Box>
  );
};
